import type { FileModel } from "#features/conversations/types/FileModel.ts";
import { create } from "zustand";

// A reply that failed to send, handed back to its conversation's composer so the user can send it again.
// The text and the files have separate owners (the composer and the upload hook), so each clears its own.
// Keyed by conversation, so a failed reply in one conversation never replaces another conversation's.
interface ComposerDraftStore {
    unsentReplies: Partial<Record<string, string>>;
    unsentFiles: Partial<Record<string, FileModel[]>>;
    restoreUnsentReply: (conversationId: string, content: string, files: FileModel[]) => void;
    clearUnsentReply: (conversationId: string) => void;
    clearUnsentFiles: (conversationId: string) => void;
}

export const useComposerDraftStore = create<ComposerDraftStore>()(set => ({
    unsentReplies: {},
    unsentFiles: {},
    restoreUnsentReply: (conversationId, content, files) => set(state => ({
        unsentReplies: { ...state.unsentReplies, [conversationId]: content },
        unsentFiles: { ...state.unsentFiles, [conversationId]: files.length > 0 ? files : undefined }
    })),
    clearUnsentReply: conversationId => set(state => ({ unsentReplies: { ...state.unsentReplies, [conversationId]: undefined } })),
    clearUnsentFiles: conversationId => set(state => ({ unsentFiles: { ...state.unsentFiles, [conversationId]: undefined } }))
}));
